module.exports = __webpack_public_path__ + "static/assets/8492fddf6e02e9859e4bbcfe0529a6e3.svg";